var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 21.893 23.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4870",
    "data-name": "Path 4870",
    d: "M20.312,16.349c-1.419-1.214-2.859-1.949-4.261-.737l-.837.732c-.612.532-1.751,3.016-6.153-2.048S7.28,8.452,7.893,7.925l.842-.733C10.129,5.977,9.6,4.448,8.6,2.874L7.99,1.92C6.98.35,5.88-.681,4.482.532l-.755.66A7.091,7.091,0,0,0,.963,5.884c-.5,3.335,1.086,7.154,4.73,11.344s7.2,6.3,10.578,6.261A7.11,7.11,0,0,0,21.3,21.407l.758-.661c1.394-1.212.528-2.446-.892-3.662Z",
    transform: "translate(-0.872 0)",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.1d72d1248e06f2162b3a3127df4b18d1.svg";
export { ForwardRef as ReactComponent };